<ng-container *ngIf="viewModel$ | async as viewModel">
    <p-button
    *ngIf="action === 'create-close'"
    [outlined]="true"
    (click)="store.dispatch(actions.createAndCloseJobButtonClicked()); buttonClicked.emit()"
    [label]="viewModel.label"
    [icon]="viewModel.icon"
    [disabled]="viewModel.disabled"
    [pTooltip]="viewModel.tooltip"
    >
    </p-button>
    <p-button
    *ngIf="action === 'create'"
    (click)="store.dispatch(actions.createJobButtonClicked()); buttonClicked.emit()"
    class="create-btn"
    [label]="viewModel.label"
    [icon]="viewModel.icon"
    [disabled]="viewModel.disabled"
    [pTooltip]="viewModel.tooltip"
    ></p-button>
    <p-button
    *ngIf="action === 'update-close'"
    (click)="store.dispatch(actions.updateAndCloseJobButtonClicked()); buttonClicked.emit()"
    [outlined]="true"
    [label]="viewModel.label"
    [icon]="viewModel.icon"
    [disabled]="viewModel.disabled"
    [pTooltip]="viewModel.tooltip"
    >
    </p-button>
    <p-button
    *ngIf="action === 'update'"
    (click)="store.dispatch(actions.updateJobButtonClicked()); buttonClicked.emit()"
    class="update-btn"
    [label]="viewModel.label"
    [icon]="viewModel.icon"
    [disabled]="viewModel.disabled"
    [pTooltip]="viewModel.tooltip"
    >
    </p-button>
</ng-container>
